import BaseModelAPI from '../BaseModelAPI';

export default class OutgoingCheckStatusList extends BaseModelAPI {

	static entity = 'outgoingcheckstatuslist'
	static entityName = 'outgoingcheckstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
